import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

import { ThunkDispatch } from "@reduxjs/toolkit";
import { State } from "../../../redux/slices";
import EditLocationForm from "./EditLocationForm";
import { SelectedLocation } from "../../../redux/slices/grainTracker/grainTrackerTypes";
import { logoutGrainTrackerE } from "../../../redux/slices/grainTracker/grainTrackerEdition";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    resetEditLocationValues: () => {
      dispatch(logoutGrainTrackerE());
    },
  };
};

export const MenuEditLocation = (
  EditingValues: boolean,
  EditingStockage: boolean,
  t: (arg0: string) => string,
  navigate: any,
  resetEditLocationValues: () => void,
  selectedLocation: SelectedLocation,
) => {
  const managingTitle = () => {
    if (EditingValues || EditingStockage) {
      return t("Edit_location.title");
    }
  };

  return (
    <div className="top-options-create-locations">
      <div className="spacer-div-back-button" />
      <div className="create-loc-title"> {managingTitle()}</div>
      <div>
        <Button
          disabled={selectedLocation.loading}
          sx={{
            fontSize: "14px",
            textTransform: "none",
            color: "#232128",
          }}
          variant="text"
          endIcon={<CloseIcon />}
          onClick={() => {
            navigate(`/site/details/${selectedLocation.values.name}`);
            setTimeout(() => {
              resetEditLocationValues();
            }, 300);
          }}
        >
          {t("Common_options.Cancel")}
        </Button>
      </div>
    </div>
  );
};

const EditLocation: FC<any> = () => {
  const [t] = useTranslation("global");
  const { resetEditLocationValues } = SetActions();
  const { locationSelectedIs } = useSelector(
    (state: State) => state.GrainWiseEditionReducer,
  );
  const { selectedLocation } = useSelector(
    (state: State) => state.GrainWiseEditionReducer,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedLocation.values.id) {
      navigate("/locations");
    }
  }, []);

  return (
    <div className="create-sites-container">
      {MenuEditLocation(
        locationSelectedIs.EditingValues,
        locationSelectedIs.EditingStockage,
        t,
        navigate,
        resetEditLocationValues,
        selectedLocation,
      )}

      {locationSelectedIs.EditingValues ? <EditLocationForm /> : ""}
    </div>
  );
};

export default EditLocation;
